import { IconCalendar } from '@consta/icons/IconCalendar'
import type { DatePickerProps } from '@consta/uikit/DatePicker'
import { DatePicker } from '@consta/uikit/DatePicker'
import { Text } from '@consta/uikit/Text'
import { TextField } from '@consta/uikit/TextField'
import type { FC } from 'react'

import type { CrmsSearchFiltersProps as Props } from '../types'
import css from './DBSearchFiltersCrms.css'

const getDateFromYear = (year: number | undefined) => (year ? new Date(year, 1) : undefined)
const textWidth = { width: '8rem' }
const datePickerProps: DatePickerProps<'year'> = {
  className: css.field,
  size: 's',
  style: { maxWidth: '15rem' },
  type: 'year',
  rightSide: IconCalendar,
  iconSize: 'xs',
  dateTimeView: 'book',
}

export const DBSearchFiltersCrms: FC<Props> = ({
  query,
  territoryChanged,
  startYearChanged,
  endYearChanged,
  executorChanged,
  projectIdChanged,
}) => {
  return (
    <div className={css.container}>
      <Text size="s" view="secondary" align="right" style={textWidth} className={css.text}>
        ЦРМС
      </Text>
      <DatePicker
        {...datePickerProps}
        placeholder="Год начала"
        value={getDateFromYear(query?.startYear)}
        onChange={value => {
          startYearChanged(value?.getFullYear())
        }}
      />
      <DatePicker
        {...datePickerProps}
        placeholder="Год окончания"
        value={getDateFromYear(query?.endYear)}
        onChange={value => {
          endYearChanged(value?.getFullYear())
        }}
      />
      <TextField
        className={css.field}
        placeholder="ID проекта"
        size="s"
        value={query?.identifier}
        onChange={projectIdChanged}
      />
      <TextField
        className={css.field}
        placeholder="Исполнитель"
        size="s"
        value={query?.executer}
        onChange={executorChanged}
      />
      <TextField
        className={css.field}
        placeholder="Территория исследования"
        size="s"
        value={query?.territory}
        onChange={territoryChanged}
      />
    </div>
  )
}
